import { css, Global } from "@emotion/react";
import styled from "@emotion/styled";
import theme from "@theme/";

const globalStyles = css`
  .smart-folder-column-select .ant-select-selector {
    border-radius: 3px !important;
  }
  .smart-folder-column-select .ant-select-selection-placeholder {
    color: black !important;
  }
  .smart-folder-column-select .ant-select-arrow {
    color: black !important;
  }

  .smart-folder-column-dropdown.ant-select-dropdown {
    z-index: 9999 !important;
    padding: 0 0 8px !important;
    overflow-y: auto !important;
  }

  .smart-folder-column-dropdown {
    max-height: 320px !important;

    .ant-select-item {
      min-height: 36px !important;
      padding: 8px 12px !important;
      display: flex !important;
      align-items: center !important;
    }

    .ant-select-item-option-content {
      min-width: 0;
      width: 100%;
    }

    .ant-select-item:last-child {
      margin-bottom: 8px !important;
    }

    .rc-virtual-list,
    .rc-virtual-list-holder,
    .rc-virtual-list-holder-inner {
      max-height: none !important;
      overflow: visible !important;
    }

    ::-webkit-scrollbar {
      width: 5px;
    }
    ::-webkit-scrollbar-track {
      background: ${theme.colors.bordertask};
    }
    ::-webkit-scrollbar-thumb {
      background: ${theme.colors.themeColor};
      border-radius: 10px;
    }
  }
`;

const ChildContainer = styled.div`
  max-height: 200px;
  overflow: auto;
  ::-webkit-scrollbar {
    width: 5px;
  }
  ::-webkit-scrollbar-track {
    background: ${theme.colors.bordertask};
  }
  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.themeColor};
    border-radius: 10px;
  }
`;

const SC = {
  Globalstyles: <Global styles={globalStyles} />,
  ChildContainer,
};

export default SC;
